import stylesheet from './Tabs.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

class NXTTabs extends CustomComponent {

    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    get tabs() {
        return this.querySelectorAll('nxt-tab');
    }

    generateTabBarItemsHtml() {
        let html = '';
        const tabs = this.tabs;
        tabs.forEach((tab) => {
            const title = tab.getAttribute('title');
            console.log(title)
            html += `<nxt-tab-bar-item>${title}</nxt-tab-bar-item>`;
        });
        console.log(html)
        return html;
    }

    render() {
        const tabsContainer = document.createElement('section');
        tabsContainer.classList.add('tab-container');
        tabsContainer.innerHTML = `
            <nxt-tab-bar>${this.generateTabBarItemsHtml()}</nxt-tab-bar>
            <div class="tab-content">
                <slot></slot>
            </div>
        `;
        console.log(tabsContainer.innerHTML)
        // Attach listeners to tabbar
        const tabBar = tabsContainer.querySelector('nxt-tab-bar');
        tabBar.addEventListener('tab-selected', (event: CustomEvent) => {
            this.switchSlide(event.detail.selectedIndex);
        });
        return tabsContainer;
    }

    switchSlide(toIndex: number) {
        this.tabs
            .forEach((el) => el.removeAttribute('active'));
        this.tabs[toIndex].setAttribute('active', 'active');
    }

}

customElements.define('nxt-tabs', NXTTabs);
